import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigureUserDialogComponent } from './configure-user-dialog.component';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { PasswordModule } from 'primeng/password';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';

@NgModule({
  declarations: [ConfigureUserDialogComponent],
  imports: [
    CommonModule,
    SelectModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicDialogModule,
    PasswordModule,
    ConfirmDialogModule,
    MessageModule,
    InputTextModule,
    CheckboxModule,
    TooltipModule,
    AccordionModule,
    ProgressSpinnerModule,
    TableModule
  ],
  exports: [ConfigureUserDialogComponent],
})
export class ConfigureUserDialogModule {}
